export default "__VITE_ASSET__$YOQnoRS__"